import styled from 'styled-components';
import colors from '../../../../assets/colors';
import AppButton from '../../../../shared/app-button';
import { default as emotionStyled } from '@emotion/styled';
import { IconButton } from '@mui/material';

const Wrapper = styled.div`
	background-color: ${p => p.theme.colors.white};
	box-shadow: 0px 2px 2px rgba(33, 33, 30, 0.1);
	border-radius: 20px;
	margin-bottom: 24px;
	overflow: auto;
	padding: 20px 0 32px;
`;

const Header = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: flex-start;
	margin-bottom: 5px;
	width: 100%;
	padding: 0 20px 24px;
`;

const Top = styled.div`
	position: relative;
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

const Bottom = styled.div`
	display: flex;
	align-items: center;
`;

const Title = styled.div`
	max-width: 100%;
`;

const Options = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	flex-wrap: wrap;
`;

const Dots = styled.button`
	background-color: transparent;
	margin-left: 20px;
	margin-top: 3px;
`;

const Details = styled.div`
	z-index: 2;
	background-color: ${p => p.theme.colors.white};
	position: absolute;
	padding: 14px;
	top: 0;
	right: -2px;
	display: flex;
	flex-direction: column;
	border: 1.5px solid ${p => p.theme.colors.grey};
	box-sizing: border-box;
	border-radius: 20px;
`;

const Sharing = styled.div`
	z-index: 2;
	background-color: ${p => p.theme.colors.white};
	position: absolute;
	padding: 16px;
	top: 0;
	right: -2px;
	display: flex;
	flex-direction: column;
	border: 1.5px solid ${p => p.theme.colors.grey};
	box-sizing: border-box;
	border-radius: 20px;
`;

const Close = styled.button`
	background-color: transparent;
	position: absolute;
	top: 12px;
	right: 15px;
`;

const Status = styled.div<{ color: keyof typeof colors }>`
	padding: 8px;
	justify-content: center;
	align-items: center;
	flex-direction: row;
	border-radius: 10px;
	background-color: ${p => p.theme.colors[p.color]};
	margin-right: 36px;
	line-height: 1.5;
`;

const StatusContainer = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	padding: 0 32px;
`;

const NoDataBlock = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 150px;
`;

const Option = styled(AppButton)``;

const DetailsButton = styled.button`
	outline: none;
	border: none;
	background: none;
	margin-left: 10px;
`;

const DetailsContainer = styled.div`
	position: absolute;
	z-index: 2;
	right: 45px;
	top: 15px;
	display: flex;
	flex-direction: column;
	background-color: ${p => p.theme.colors.white};
	border: 1px solid #ccd2d9;
	border-radius: 20px;
	margin-bottom: 24px;
	padding: 20px 2px;
	width: 150px;
`;

const CircleButtonsWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;
`;

const CircleButton = emotionStyled(IconButton)`
	width: 40px;
	height: 40px;
	padding: 10px;
	border: 1px solid #CCD2D9;
	cursor: pointer;
`;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
	Wrapper,
	Header,
	DetailsContainer,
	DetailsButton,
	Option,
	Top,
	Bottom,
	Title,
	Options,
	Dots,
	Details,
	Sharing,
	Close,
	Status,
	StatusContainer,
	NoDataBlock,
	CircleButtonsWrapper,
	CircleButton,
};
